// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2n8b8","bigColWidth":"Table_bigColWidth__1OJzU","biggerColWidth":"Table_biggerColWidth__2CdY3","row":"Table_row__VZmSF","col":"Table_col__9C66b"};